import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/exam";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/exam")(withAlternates(routeOptions, "/exam"));
